import React from 'react';
import { Module } from './types/moduleTypes';
import { 
  BookOpen, 
  ClipboardList, 
  Settings, 
  Shield, 
  Zap, 
  Clock, 
  Wrench, 
  HelpCircle, 
  Moon, 
  Heart
} from 'lucide-react';

export const allModules: Module[] = [
  {
    id: "module-1",
    title: "Módulo 1 - Apresentação",
    description: "Aqui começa o fim da dor na sua amamentação",
    topics: [
      "Seja-Bem vinda"
    ],
    icon: <BookOpen className="h-8 w-8" />
  },
  {
    id: "module-2",
    title: "Módulo 2 - Método PPS na prática (Posição, Pega e Sucção)",
    description: "Aplicação prática do Método PPS em consultorias e atendimentos clínicos",
    topics: [
      "Preparo da Mama para Amamentar",
      "Massagem nas mamas para amolecer aréola e facilitar a pega",
      "Posições da Mãe para Amamentar",
      "Posições (Mães e Bebês reais)",
      "Posições do Bebê para Mamar",
      "Posição Para Amamentar Deitada e pós-cesárea",
      "Posições para Amamentar Gêmeos",
      "Como Estimular o Reflexo de Abertura da Boca do Bebê para Fazer a Pega Correta",
      "Reflexo de abertura da boca do bebê na prática",
      "Como Fazer Prega de Apoio na Mama",
      "Passo a Passo da Pega Correta",
      "Como Ajustar a Pega e Acabar com a Dor",
      "Técnica para Remover o Bebê do Seio sem Sentir Dor",
      "Como Saber se o Bebê está Mamando Bem Através da Sucção Efetiva",
      "Identificando a sucção efetiva na prática"
    ],
    icon: <ClipboardList className="h-8 w-8" />
  },
  {
    id: "module-3",
    title: "Módulo 3 - Base Teórica da Amamentação",
    description: "Fundamentos científicos essenciais para orientação profissional em aleitamento materno",
    topics: [
      "Benefícios Exclusivos do Leite Materno",
      "Instinto ou Aprendizado?",
      "O Real Preparo das Mamas na Gestação",
      "Será que Todas as Mamas e Mamilos são Bons para Amamentar? Descubra qual o seu tipo!",
      "Impactos da Via de Nascimento (parto ou Cesárea) na Amamentação",
      "Porque Amamentar na Hora Dourada",
      "Como Funcionam a Produção e Fluxo de Leite no pós-parto",
      "Segredos para Favorecer e Acelerar a Apojadura (Descida do Leite)",
      "Rede de Apoio na Amamentação",
      "Uso de Bicos Artificiais e seu Impacto Direto na Amamentação",
      "Desvendando as Necessidades do Recém-Nascido"
    ],
    icon: <Settings className="h-8 w-8" />
  },
  {
    id: "module-4",
    title: "Módulo 4 - Identificando e resolvendo dificuldades",
    description: "Diagnóstico profissional de dificuldades e problemas na amamentação",
    topics: [
      "Bebê que Não Consegue Fazer a Pega e/ou Manter a Sucção",
      "Confusão de Sucção (bicos) e Fluxo",
      "Atraso na Apojadura (descida do leite)",
      "Dor na Amamentação",
      "Lesões Mamilares",
      "Ingurgitamento Mamário (Mamas Empedradas)",
      "Bloqueio de Ductos",
      "Mastite",
      "Abcesso Mamário",
      "Candidíase Mamária",
      "Fenômeno de Raynaud nos Mamilos",
      "Fenômeno de Raynaud",
      "DMER (Reflexo Disfórico da Ejeção do Leite)",
      "Perturbação na Amamentação",
      "Hiperfluxo (Reflexo Exacerbado de Ejeção do Leite)",
      "Hiperlactação (Hiper Produção de Leite)",
      "Hipogalactia (Baixa Produção de Leite)",
      "Retomando o Aleitamento Materno Exclusivo após Usar Complemento",
      "Bebês Sonolentos Demais",
      "Bebês Irritados que Brigam ou Recusam o Seio",
      "Bebês que Preferem Mamar em Um Seio",
      "Como Lidar com as Mordidas do Bebê"
    ],
    icon: <Shield className="h-8 w-8" />
  },
  {
    id: "module-5",
    title: "Módulo 5 - Técnicas Práticas para Resolução de Dificuldades",
    description: "Intervenções técnicas especializadas para resolução de problemas complexos",
    topics: [
      "Como Ativar o Reflexo de Ejeção do Leite para Facilitar a Pega do Bebê",
      "Como Fazer Extração de Alívio das Mamas Empedradas",
      "Massagem aliviar mamas + Téc. Shake",
      "Uso Correto das Compressas Frias e Quentes + Repolho nas Mamas",
      "Como preparar compressa com Repolho",
      "Técnica da Compressão Mamária",
      "Téc. Compressão Mamária",
      "Desbloqueio dos Ductos",
      "Técnica da Translactação / Relactação",
      "Translactação / Relactação na prática",
      "Como Fazer Extração Manual do Leite Materno",
      "Massagem e Ordenha manual na prática",
      "Power Pumping e Protocolo Padrão de Ordenha para Estímulo e Produção de Leite",
      "Como Armazenar e Aquecer o Leite Materno Ordenhado",
      "Como Ofertar Complemento no Copinho, Colher Dosadora e Seringa",
      "(Bebê real) Como ofertar leite no copinho",
      "Como Usar o Bico Intermediário de Silicone",
      "Uso correto do Bico Intermediário",
      "Como Remover o Uso do Bico Intermediário de Silicone",
      "Uso Correto do Eversor / Protrusor de Mamilos Planos"
    ],
    icon: <HelpCircle className="h-8 w-8" />
  },
  {
    id: "module-6",
    title: "Módulo 6 - Amamentação em Situações Específicas da mãe e do Bebê",
    description: "Atendimento especializado em situações específicas e casos especiais",
    topics: [
      "Mamas Grandes e Pendulares",
      "Mamas com Hipoplasia Glandular",
      "Mamas com Prótese de Silicone",
      "Mamas com Mamoplastia Redutora",
      "Mastectomia",
      "Mamilos Planos",
      "Mamilos Invertidos",
      "Mamilos Planos e Invertidos",
      "Mamilos Muito Grandes (Hipertróficos)",
      "Bebês PIG (Pequenos para a Idade Gestacional) e GIG (Grandes para a Idade Gestacional)",
      "Bebês Prematuros",
      "Bebê com Cólica",
      "Bebê com Hipoglicemia Neonatal",
      "Bebê com Desidratação",
      "Bebê com Icterícia Neonatal (amarelão)",
      "Bebê com Doença do Refluxo Gastroesofágico (DRGE)",
      "Bebê com Alergia à Proteína do Leite de Vaca (APLV)",
      "Bebê com Baixo Ganho ou Perda de Peso em Aleitamento Exclusivo",
      "Bebê com Alterações na Cavidade Oral e/ou Disfunções Orais",
      "Bebês com Laringomalácia",
      "Bebês em Situações Especiais"
    ],
    icon: <Clock className="h-8 w-8" />
  },
  {
    id: "module-7",
    title: "Módulo 7 - Rotinas de Amamentação e do Bebê",
    description: "Orientação profissional sobre livre demanda e manejo clínico",
    topics: [
      "Livre Demanda: Quantidade, Duração e Intervalo das Mamadas",
      "Primeiras Horas de Vida do Bebê e a Amamentação",
      "Amamentação Noturna: Acordar ou Não o Bebê para Mamar?",
      "Dar Um ou os Dois Seios na Mesma Mamada",
      "Sinais de Fome do Bebê",
      "Sinais que o Bebê está Mamando Bem",
      "Rotina da Amamentação de Gêmeos",
      "Como Acalmar o Bebê para Mamar",
      "Como acalmar o bebê",
      "Irritação nas Mamadas do Final do dia/início da noite (Hora da Bruxa)",
      "Troca de Fraldas Antes ou Após as Mamadas",
      "Como Fazer o Bebê Arrotar",
      "Como Desengasgar o Bebê"
    ],
    icon: <Wrench className="h-8 w-8" />
  },
  {
    id: "module-8",
    title: "Módulo 8 - Como usar dispositivos e equipamentos",
    description: "Prescrição e orientação profissional sobre equipamentos e dispositivos",
    topics: [
      "Como Escolher Corretamente a Poltrona e Almofada de Amamentação",
      "Conchas de Silicone e Rolinhos / Rosquinhas de Pano",
      "Pomadas para Lesões Mamilares",
      "Absorvente para Seios",
      "Coletor de Leite Materno",
      "Uso do coletor de leite",
      "Bombas Extratoras de Leite Materno (Manuais e Elétricas)",
      "Recipientes para Armazenamento do Leite Materno",
      "Uso da Chupeta",
      "Mamadeira (Paced Feeding)",
      "Paced Feeding",
      "Higiene dos Equipamentos e Dispositivos"
    ],
    icon: <Zap className="h-8 w-8" />
  },
  {
    id: "module-9",
    title: "Módulo 9 - Dúvidas Maternas mais comuns",
    description: "Base científica para desmistificação e educação de pacientes",
    topics: [
      "Posso Ingerir Alimentos ou Bebidas Estimulantes (café, chá, chocolate, refrigerantes)?",
      "Posso Usar Medicamentos e/ou Drogas Durante a Amamentação?",
      "Posso Ingerir Bebidas Alcoólicas?",
      "Posso Tomar Anticoncepcional Enquanto Amamento?",
      "Posso Engravidar Amamentando?",
      "Posso Amamentar se eu Estiver Doente?",
      "O Estado Emocional da Mãe pode Afetar a Amamentação?",
      "Posso fazer Exercícios Físicos?",
      "Posso Fazer Química nos Cabelos?",
      "Preciso Limpar a Boquinha do Bebê após a Mamada?",
      "Alimentação e Hidratação da Mãe que Amamenta"
    ],
    icon: <Moon className="h-8 w-8" />
  },
  {
    id: "module-10",
    title: "Módulo 10 - Bônus Extras",
    description: "Recursos complementares para prática profissional especializada",
    topics: [
      "Exterogestação e Técnicas para Acalmar o Bebê",
      "Meditação Guiada na Amamentação",
      "Puerpério: Questões Emocionais Maternas",
      "Estimulação Sensorial no Bebê",
      "Osteopatia no Auxílio da Amamentação",
      "Uso do Sling e Banho de Ofurô",
      "Introdução dos Alimentos Sólidos",
      "Como Ensinar o Bebê a Dormir",
      "Como Identificar e Aliviar as Cólicas do Bebê",
      "Cuidados com o Recém-Nascido"
    ],
    icon: <Heart className="h-8 w-8" />
  }
];